import React, { useEffect, useState, useMemo } from 'react';
import { getTrades } from '../api';
import TickerDetail from './TickerDetail';

export default function TradingTickerPage({ ticker, onBack }) {
  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    getTrades({ ticker, limit: 1000 })
      .then(r => setTrades(r.data.trades || []))
      .catch(() => setError('Не вдалося завантажити угоди'))
      .finally(() => setLoading(false));
  }, [ticker]);

  // Adapt API trade format to TickerDetail's expected format
  const adaptedTrades = useMemo(() =>
    trades.map(t => ({
      ...t,
      time:        t.timestamp,   // TickerDetail uses .time
      description: t.reason,      // TickerDetail uses .description
      change_usd:  t.pnl_usd,     // TickerDetail uses .change_usd for pnlUsd
    })),
    [trades]
  );

  // Build tradeContext: date range = earliest - 5d … latest + 5d
  const tradeContext = useMemo(() => {
    if (!adaptedTrades.length) return null;
    const times  = adaptedTrades.map(t => new Date(t.time)).filter(d => !isNaN(d));
    if (!times.length) return null;
    const minD = new Date(Math.min(...times.map(d => d.getTime())));
    const maxD = new Date(Math.max(...times.map(d => d.getTime())));
    minD.setDate(minD.getDate() - 5);
    maxD.setDate(maxD.getDate() + 5);
    return {
      ticker,
      dataType:        'daily',
      allTickerTrades: adaptedTrades,
      fromDate:        minD.toISOString().slice(0, 10),
      toDate:          maxD.toISOString().slice(0, 10),
    };
  }, [adaptedTrades, ticker]);

  const fakeTicker = {
    ticker,
    name:   ticker,
    daily:  { has_data: true },
    hourly: { has_data: true },
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', color: '#6B7280', fontSize: 15 }}>
        Завантаження…
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', color: '#DC2626', fontSize: 15 }}>
        {error}
      </div>
    );
  }

  return (
    <TickerDetail
      ticker={fakeTicker}
      tradeContext={tradeContext}
      onBack={onBack}
    />
  );
}
